/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateRollupChildRequest
 */
export interface UpdateRollupChildRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateRollupChildRequest
     */
    weight: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateRollupChildRequest
     */
    rationale?: string;
}

/**
 * Check if a given object implements the UpdateRollupChildRequest interface.
 */
export function instanceOfUpdateRollupChildRequest(value: object): value is UpdateRollupChildRequest {
    if (!('weight' in value) || value['weight'] === undefined) return false;
    return true;
}

export function UpdateRollupChildRequestFromJSON(json: any): UpdateRollupChildRequest {
    return UpdateRollupChildRequestFromJSONTyped(json, false);
}

export function UpdateRollupChildRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateRollupChildRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'weight': json['weight'],
        'rationale': json['rationale'] == null ? undefined : json['rationale'],
    };
}

export function UpdateRollupChildRequestToJSON(json: any): UpdateRollupChildRequest {
    return UpdateRollupChildRequestToJSONTyped(json, false);
}

export function UpdateRollupChildRequestToJSONTyped(value?: UpdateRollupChildRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'weight': value['weight'],
        'rationale': value['rationale'],
    };
}

